// https://github.com/duskload/mobile-device-detect#readme
import { isTablet, isMobileOnly } from "mobile-device-detect";

export default class BrowserHelper {
  constructor() {}

  get mobile() {
    return isMobileOnly;
  }

  get tablet() {
    return isTablet;
  }
}
